/// <reference types="@angular/localize" />

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from '@app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
	enableProdMode();
}

const platformRef = platformBrowserDynamic();

/*
	We are wrapping the bootstraping of a module in a setTimeout to ensure that it is run as a
	macrotask. This code can be returned back to normal once the numer of dependencies for
	the AppModule decreses or when we are able to output ESM into bundles. As for now,
	the instance creation of all services the AppModule depend on, is considered a long task.
	Thus, this is a hot-fix for giving the browser a window to perform other work, such as
	loading critical resources etc.
 */
setTimeout(() => platformRef.bootstrapModule(AppModule).catch(err => console.log(err)));
